var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDummyVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 3.2H0V14.4C0 15.284 0.716 16 1.6 16H12.8V14.4H1.6V3.2ZM14.4 0H4.8C3.916 0 3.2 0.716 3.2 1.6V11.2C3.2 12.084 3.916 12.8 4.8 12.8H14.4C15.284 12.8 16 12.084 16 11.2V1.6C16 0.716 15.284 0 14.4 0ZM8 10V2.8L12.8 6.4L8 10Z",
    fill: "#34629A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyVideo);
export default __webpack_public_path__ + "static/media/dummy-video.120c9ca496b97889ed29fe06acecdda6.svg";
export { ForwardRef as ReactComponent };